import { createStore, createEffect, createEvent, combine } from 'effector';
import i18n from 'i18n';
import { $notificationStore } from '../notificationStore';
import { DashboardApi } from '@shared/api/rest';
import { ApiUtils } from '@shared/utils';
import { type IQueryParams, RequestStrategyEnum } from '@shared/api/models';
import type { PaymentSummariesRequest, PaymentSummariesResponse } from '@shared/api/rest/dashboards';

const effect = createEffect((params: IQueryParams<PaymentSummariesRequest>) => DashboardApi.getPaymentSummary(params.request, params?.signal));
const clearEvent = createEvent();

const $dataStore = createStore<PaymentSummariesResponse | {}>({
  outgoingTransactions: {
    amount: 0,
    numberOfTransaction: 0,
    highestTransferAmount: [],
    recurrentRecipientsInfo: [],
  },
  incomingTransactions: {
    amount: 0,
    numberOfTransaction: 0,
    highestTransferAmount: [],
    recurrentRecipientsInfo: [],
  },
  outgoingTransactionSummary: {
    numberOfOutgoingPayments: 0,
    numberOfApprovedOutgoingPayments: 0,
    numberOfRejectedOutgoingPayments: 0,
    amountOfApprovedOutgoingPayments: 0,
    amountOfRejectedOutgoingPayments: 0,
  },
})
  .on(effect.done, (state, { result }) => result.data ?? {})
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(effect.pending, (_, data) => data)
  .on(effect.fail, (_, data) => ApiUtils.abortApiFailCaseTrigger(data))
  .on(effect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(effect, () => null)
  .on(effect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(effect.done, () => null)
  .reset(clearEvent);
$errorStore.watch((x) => {
  ApiUtils.errorStoreAbortRequestWatcher(x, $notificationStore.events.setError);
});

export const $monthlyTransactionStore = {
  events: {
    update: ApiUtils.wrapperApi(effect, RequestStrategyEnum.Debounce),
    clear: clearEvent,
  },
  store: combine({
    data: $dataStore,
    loading: $loadingStore,
    error: $errorStore,
  }),
};
